import React from 'react';
import { Index } from 'react-instantsearch-core';
import {
  productsIndex_DE,
  productsIndex_US,
  productsQuerySuggestionsIndex_DE,
  productsQuerySuggestionsIndex_US,
} from 'helpers/constants/algolia';
import useLocale from 'helpers/hooks/useLocale';
import { getCurrencyCookie } from 'helpers/utils/getCurrencyCookie';

interface Props {
  type: 'products' | 'query-suggestions';
}

export const useLocalizedIndex = ({ type }: Props) => {
  const { ctLocale: locale } = useLocale();

  const localeSelection = getCurrencyCookie('locale_selection');
  const currency: string = localeSelection?.currency || null;

  const indexes = {
    products: {
      en: productsIndex_US,
      de: productsIndex_DE,
    },
    'query-suggestions': {
      en: productsQuerySuggestionsIndex_US,
      de: productsQuerySuggestionsIndex_DE,
    },
  };

  const newLocale = currency === 'GBP' ? 'en' : 'de';
  const indexName = indexes[type][newLocale as 'en' | 'de'];

  return { indexName };
};

const LocalizedIndex = ({ children, type }: React.PropsWithChildren<Props>) => {
  const { indexName } = useLocalizedIndex({ type });

  return <Index indexName={indexName}>{children}</Index>;
};

export default LocalizedIndex;
